/* tslint:disable */
/* eslint-disable */
/**
 * KPI Manage API
 * KPIの情報を操作するAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface DimensionInfo
 */
export interface DimensionInfo {
    /**
     * 
     * @type {string}
     * @memberof DimensionInfo
     */
    'dimensionType': string;
    /**
     * 
     * @type {DimensionInfoDimensionValue}
     * @memberof DimensionInfo
     */
    'dimensionValue': DimensionInfoDimensionValue;
}
/**
 * 
 * @export
 * @interface DimensionInfoDimensionValue
 */
export interface DimensionInfoDimensionValue {
    /**
     * 
     * @type {string}
     * @memberof DimensionInfoDimensionValue
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DimensionInfoDimensionValue
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DimensionInfoDimensionValue
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof DimensionInfoDimensionValue
     */
    'unit'?: string;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 
 * @export
 * @interface GetKpiSuccessResponse
 */
export interface GetKpiSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetKpiSuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetKpiSuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetKpiSuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {KpiInfo}
     * @memberof GetKpiSuccessResponse
     */
    'result': KpiInfo;
}
/**
 * 
 * @export
 * @interface KpiFactInfo
 */
export interface KpiFactInfo {
    /**
     * 
     * @type {string}
     * @memberof KpiFactInfo
     */
    'kpiValue': string;
    /**
     * 
     * @type {Array<DimensionInfo>}
     * @memberof KpiFactInfo
     */
    'dimensions': Array<DimensionInfo>;
}
/**
 * 
 * @export
 * @interface KpiInfo
 */
export interface KpiInfo {
    /**
     * 
     * @type {string}
     * @memberof KpiInfo
     */
    'metricType': string;
    /**
     * 
     * @type {Array<KpiFactInfo>}
     * @memberof KpiInfo
     */
    'kpis': Array<KpiFactInfo>;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}

/**
 * KpiApi - axios parameter creator
 * @export
 */
export const KpiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary KPI情報を取得する
         * @param {string} metricType 分析種類
         * @param {string} dimensionTypes 分析切り口情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKpi: async (metricType: string, dimensionTypes: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricType' is not null or undefined
            assertParamExists('getKpi', 'metricType', metricType)
            // verify required parameter 'dimensionTypes' is not null or undefined
            assertParamExists('getKpi', 'dimensionTypes', dimensionTypes)
            const localVarPath = `/kpi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricType !== undefined) {
                localVarQueryParameter['metric_type'] = metricType;
            }

            if (dimensionTypes !== undefined) {
                localVarQueryParameter['dimension_types'] = dimensionTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary KPI情報をPOSTする
         * @param {KpiInfo} kpiInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKpi: async (kpiInfo: KpiInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kpiInfo' is not null or undefined
            assertParamExists('postKpi', 'kpiInfo', kpiInfo)
            const localVarPath = `/kpi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(kpiInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KpiApi - functional programming interface
 * @export
 */
export const KpiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KpiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary KPI情報を取得する
         * @param {string} metricType 分析種類
         * @param {string} dimensionTypes 分析切り口情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKpi(metricType: string, dimensionTypes: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetKpiSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKpi(metricType, dimensionTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KpiApi.getKpi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary KPI情報をPOSTする
         * @param {KpiInfo} kpiInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postKpi(kpiInfo: KpiInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postKpi(kpiInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KpiApi.postKpi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KpiApi - factory interface
 * @export
 */
export const KpiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KpiApiFp(configuration)
    return {
        /**
         * 
         * @summary KPI情報を取得する
         * @param {string} metricType 分析種類
         * @param {string} dimensionTypes 分析切り口情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKpi(metricType: string, dimensionTypes: string, options?: any): AxiosPromise<GetKpiSuccessResponse> {
            return localVarFp.getKpi(metricType, dimensionTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary KPI情報をPOSTする
         * @param {KpiInfo} kpiInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKpi(kpiInfo: KpiInfo, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.postKpi(kpiInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KpiApi - object-oriented interface
 * @export
 * @class KpiApi
 * @extends {BaseAPI}
 */
export class KpiApi extends BaseAPI {
    /**
     * 
     * @summary KPI情報を取得する
     * @param {string} metricType 分析種類
     * @param {string} dimensionTypes 分析切り口情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KpiApi
     */
    public getKpi(metricType: string, dimensionTypes: string, options?: RawAxiosRequestConfig) {
        return KpiApiFp(this.configuration).getKpi(metricType, dimensionTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary KPI情報をPOSTする
     * @param {KpiInfo} kpiInfo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KpiApi
     */
    public postKpi(kpiInfo: KpiInfo, options?: RawAxiosRequestConfig) {
        return KpiApiFp(this.configuration).postKpi(kpiInfo, options).then((request) => request(this.axios, this.basePath));
    }
}



